import React, { useCallback, useEffect, useRef, useState } from 'react'
import PreviewOrderModal from '../../../../components/PreviewOrderModal';
import { SearchIcon } from '@chakra-ui/icons';
import { Checkbox, Box, Flex, Text, Stack, Tabs, Button, TabList, TabPanels, Tab, TabPanel, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Avatar, Badge, IconButton, Input, InputGroup, InputLeftElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Skeleton, SkeletonCircle, Switch, Table, TableCaption, TableContainer, Tbody, Td, Tfoot, Th, Thead, Tr, useColorModeValue, useDisclosure, useToast, Breadcrumb, BreadcrumbItem, BreadcrumbLink, FormControl, FormLabel, SimpleGrid, Card, CardBody, Image, Heading, Portal, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverBody, InputRightElement, CloseButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TbListDetails } from 'react-icons/tb';
import { useStateContext } from '../../../../context/ContextProvider';
import axiosClient from '../../../../axios-client';
import MyPagination from '../../../../components/MyPagination';
import { FaRegEye } from 'react-icons/fa6';
import { RiFileTransferLine, RiUserShared2Line } from 'react-icons/ri';
import { CiMenuKebab } from 'react-icons/ci';
import BulkStatusUpdateModal from '../../../../components/BulkStatusUpdateModal';
import { AsyncPaginate } from 'react-select-async-paginate';
import { DateRange } from 'react-date-range';
import format from 'date-fns/format';
import fr from 'date-fns/locale/fr';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { usePersistedListState, useScrollRestore } from '../../../../hooks/usePersistedListState';
import { GrPowerReset } from 'react-icons/gr';
import { useDebounce } from '../../../../hooks/useDebounce';

let isFirstLoad_GestSuivi = true;
function GestSuivi() {
    const bgPurple = useColorModeValue("purple.50", "purple.900");
    const { user, setToken, setUser, currentBusiness } = useStateContext()
    const navigate = useNavigate()
    const { t } = useTranslation();
    const toast = useToast()


    const [statusDelivery, setStatusDelivery] = useState('')

    const [dataOrder, setDataOrder] = useState([])

    const [selectedRows, setSelectedRows] = useState([]);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allIds = dataOrder.map(val => val.id);
            setSelectedRows(allIds);
        } else {
            setSelectedRows([]);
        }
    };

    const handleCheckboxClick = (id) => {
        setSelectedRows(prev =>
            prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]
        );
    };
    const [isBulkSubmitting, setIsBulkSubmitting] = useState(false);
    const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);

    const assign_order_to = (userId) => {
        if (isBulkSubmitting) return;
        setIsBulkSubmitting(true);
        axiosClient.post('/commandes/assign_order_to_me/', {
            user_id: userId,
            order_ids: selectedRows
        }).then(res => {
            const abortController = new AbortController();
            fetchData(abortController.signal);
            const results = res.data.results || [];
            const errors = results.filter(r => !r.success);
            if (errors.length > 0) {
                errors.forEach(err => {
                    toast({
                        description: `Erreur - Commande ${err.order_code}: ${err.message}`,
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                });
            }
            setSelectedRows([]);
        }).catch(err => {
            toast({
                description: t("Erreur lors de l'attribution"),
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right'
            });
        }).finally(() => {
            setIsBulkSubmitting(false);
        });
    };

    const [paginationData, setPaginationData] = useState()
    const [loading, setLoading] = useState(true)


    const {
        currentPage, setCurrentPage,
        pageSize, setPageSize,
        searchTerm, setSearchTerm,
        userSelected, setUserSelected,
        statusSelected, setStatusSelected,
        dateDebutValue, setDateDebutValue,
        dateFinValue, setDateFinValue,
        selectedProduct, setSelectedProduct,
        saveScrollPosition
    } = usePersistedListState('GestSuivi');
    const tableRef = useRef(null);
    useScrollRestore('GestSuivi', loading, tableRef);

    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });

    const handleSelectDateRange = (ranges) => {
        const { startDate, endDate } = ranges.selection;
        setSelectionRange(ranges.selection);
        setDateDebutValue(format(startDate, 'yyyy-MM-dd'));
        setDateFinValue(format(endDate, 'yyyy-MM-dd'));
    };

    const clearDateRange = () => {
        setDateDebutValue("");
        setDateFinValue("");
        setSelectionRange({
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        });
    };



    const selectTextColor = useColorModeValue('black', 'white'); // trigger rebuild
    const selectBg = useColorModeValue('transparent', 'transparent');
    const selectMenuBg = useColorModeValue('white', '#2D3748');
    const selectBorderColor = useColorModeValue('#E2E8F0', 'rgba(255, 255, 255, 0.16)');
    const selectHoverBg = useColorModeValue('#EDF2F7', '#4A5568');

    const loadProductOptions = async (search, loadedOptions, { page }) => {
        try {
            const res = await axiosClient.get(`/products/get_All_Products_names/?client=${user?.id}&page_size=20&page=${page}&search_term=${search}&userRole=${user?.role}&business=${currentBusiness?.id}`, { hideLoader: true });
            const results = res.data.results || [];
            const hasMore = res.data.next !== null && res.data.next !== undefined;
            return {
                options: results.map(product => ({ value: product.id, label: product.title })),
                hasMore,
                additional: { page: page + 1 },
            };
        } catch (error) {
            // // console.error('Error fetching products', error);
            return { options: [], hasMore: false };
        }
    };

    // PAGINATION

    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };

    const debouncedSearchTerm = useDebounce(searchTerm, 500);

    const fetchData = useCallback(async (signal) => {
        try {
            setLoading(true)
            const res = await axiosClient.get(`/commandes/getSuiviOrder/?clientId=${user.id}&page_size=${pageSize}&page=${currentPage + 1}&search_term=${debouncedSearchTerm}&statusSelected=${statusSelected}&dateDebut=${dateDebutValue}&dateFin=${dateFinValue}&product=${selectedProduct ? selectedProduct.value : ''}&business=${currentBusiness?.id}`, { signal, hideLoader: !isFirstLoad_GestSuivi });
            isFirstLoad_GestSuivi = false;
            
            if (res.data.length !== 0) {
                setDataOrder(res.data.results)
                setPaginationData(res.data)
            } else {
                setDataOrder([])
                setPaginationData([])
            }

            if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");

                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
            }
            setLoading(false)
        } catch (error) {
            if (error.name !== 'CanceledError' && error.message !== 'canceled') {
                setLoading(false)
            }
        }
    }, [user?.id, currentPage, debouncedSearchTerm, pageSize, statusSelected, dateDebutValue, dateFinValue, selectedProduct, currentBusiness?.id]);

    useEffect(() => {
        const abortController = new AbortController();
        fetchData(abortController.signal);
        return () => abortController.abort();
    }, [fetchData])

    // Update status

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const cancelRef = React.useRef()
    const [statusId, setStatusId] = useState()

    const onOpenAlert = (id) => {
        setIsAlertOpen(true);
        setStatusId(id)
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
        setStatusDelivery('')
        setStatusId()
    };

    const HandleChangeStatus = async () => {
        if (isUpdatingStatus) return;
        setIsUpdatingStatus(true);
        try {
            await axiosClient.patch(`commandes/${statusId}/`, {
                status_delivery: statusDelivery
            }).then((res) => {
                setDataOrder(dataOrder.map((item) => {
                    if (item.id === res.data.id) {
                        return {
                            ...item,
                            status_delivery: res.data.status_delivery
                        }
                    }
                    return item
                }))
                onCloseAlert()
                toast({
                    description: t(`Statut est changé avec succès`),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            console.error('ERROR : ', error);
            toast({
                description: t("Une erreur s'est produite"),
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right'
            });
        } finally {
            setIsUpdatingStatus(false);
        }
    }

    const borderColor = useColorModeValue("gray.300", "gray.600")
    const textSM = useColorModeValue('gray.400', 'gray.500')
    const bgStack = useColorModeValue('white', 'gray.700')

    const resetFilters = () => {
        setSearchTerm('');
        setStatusSelected('');
        clearDateRange();
        setSelectedProduct(null);
        setCurrentPage(0);
    };

    //vider l'input de date fin
    useEffect(() => {
        if (!dateDebutValue) {
            // Si dateDebutValue est vide, on réinitialise dateFinValue
            setDateFinValue('');
        } else if (dateFinValue && dateDebutValue >= dateFinValue) {
            // Si dateDebutValue est supérieur ou égal à dateFinValue, on réinitialise dateFinValue
            setDateFinValue('');
        }
    }, [dateDebutValue, dateFinValue]);

    // Aperçu Commande
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [previewId, setPreviewId] = useState(null);

    const onOpenPreview = (id) => {
        setPreviewId(id);
        setIsPreviewOpen(true);
    };

    const onClosePreview = () => {
        setIsPreviewOpen(false);
        setPreviewId(null);
    };

    return (
        <Box mt="5px">

            <Flex>
                <Box w="90%" mt={2} mb={5}>
                    <Breadcrumb fontStyle={"normal"} fontSize={{ base: "14px", sm: "14px", lg: "15px" }} color="gray.400" letterSpacing="-0.01em">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>

                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Gestion suivi")}</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Box>
            </Flex>

            <Flex
                px={2}
                py={5}
                mx={5}
                bg={bgStack}
                rounded={"2xl"}
                mt={2}
                align={'center'}
                justify={'center'}

            >

                <Stack
                    w={'full'}
                    maxW='full'
                    rounded={'lg'}
                    mt={2}
                    px={{ base: 1, md: 5 }}
                >
                    {/* Search input */}
                    <Flex align="center" gap={3} w="full" direction={{ base: 'column', lg: 'row' }} justify="space-between" mb={6}>
                        <Flex gap={3} w="full" direction={{ base: 'column', md: 'row' }} flexWrap="wrap">
                            <Select
                                borderColor={borderColor}
                                borderRadius="xl"
                                size="md"
                                fontSize={{ base: 13, lg: 16 }}
                                w={{ base: '100%', md: '200px' }}
                                value={statusSelected}
                                onChange={(e) => {
                                    setCurrentPage(0)
                                    setStatusSelected(e.target.value)
                                }}
                            >
                                <option value="">{t("Statut de suivi")}</option>
                                <option value='Nouveau'>{t('Nouveau')}</option>
                                <option value='Ramassé'>{t('Ramassé')}</option>
                                <option value='Expédié'>{t('Expédié')}</option>
                                <option value='Reçu à destination'>{t('Reçu à destination')}</option>
                                <option value='Pendant la distribution'>{t('Pendant la distribution')}</option>
                                <option value='Programmé'>{t('Programmé')}</option>
                                <option value='Hors zone'>{t('Hors zone')}</option>
                                <option value='Non atteint'>{t('Non atteint')}</option>
                                <option value='Annulé'>{t('Annulé')}</option>
                                <option value='Refusé'>{t('Refusé')}</option>
                                <option value='Livré'>{t('Livré')}</option>
                                <option value='Préparation du retour'>{t('Préparation du retour')}</option>
                                <option value="Retour à l'agence">{t("Retour à l'agence")}</option>
                                <option value="Retour à l'entrepôt">{t("Retour à l'entrepôt")}</option>
                            </Select>

                            <Box w={{ base: '100%', md: '200px' }}>
                                <AsyncPaginate
                                    loadOptions={loadProductOptions}
                                    onChange={(option) => {
                                        setCurrentPage(0);
                                        setSelectedProduct(option);
                                    }}
                                    value={selectedProduct}
                                    isClearable
                                    placeholder={t('Produit...')}
                                    noOptionsMessage={() => t('Aucun produit trouvé')}
                                    additional={{ page: 1 }}
                                    styles={{
                                        control: (p) => ({ ...p, backgroundColor: selectBg, borderColor: selectBorderColor, color: selectTextColor, minHeight: '40px', borderRadius: '12px' }),
                                        menu: (p) => ({ ...p, zIndex: 9999, backgroundColor: selectMenuBg, borderRadius: '12px' }),
                                        option: (p, s) => ({ ...p, backgroundColor: s.isFocused ? selectHoverBg : 'transparent', color: selectTextColor }),
                                        singleValue: (p) => ({ ...p, color: selectTextColor }),
                                        input: (p) => ({ ...p, color: selectTextColor }),
                                    }}
                                />
                            </Box>

                            <Box w={{ base: '100%', md: '250px' }}>
                                <Popover placement="bottom-start">
                                    <PopoverTrigger>
                                        <InputGroup size="md">
                                            <Input
                                                readOnly
                                                value={dateDebutValue ? `${dateDebutValue} ${t("au")} ${dateFinValue}` : t("Choisir une période")}
                                                cursor="pointer"
                                                rounded="xl"
                                                borderColor={borderColor}
                                                bg={useColorModeValue('white', 'gray.700')}
                                                _hover={{ borderColor: 'purple.400' }}
                                                _focus={{ borderColor: 'purple.500', boxShadow: 'none' }}
                                            />
                                            {dateDebutValue && (
                                                <InputRightElement w="auto" pr={2}>
                                                    <IconButton
                                                        variant="ghost"
                                                        size="sm"
                                                        icon={<CloseButton size="sm" />}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            clearDateRange();
                                                        }}
                                                        aria-label={t("Effacer la date")}
                                                    />
                                                </InputRightElement>
                                            )}
                                        </InputGroup>
                                    </PopoverTrigger>
                                    <Portal>
                                        <PopoverContent w="auto" p={0} border="none" shadow="2xl" zIndex={9999}>
                                            <PopoverArrow />
                                            <PopoverBody p={0}>
                                                <DateRange
                                                    ranges={[selectionRange]}
                                                    onChange={handleSelectDateRange}
                                                    locale={fr}
                                                    maxDate={new Date()}
                                                    rangeColors={['#805AD5']}
                                                />
                                            </PopoverBody>
                                        </PopoverContent>
                                    </Portal>
                                </Popover>
                            </Box>

                            <InputGroup size="md" w={{ base: '100%', md: '200px' }}>
                                <InputLeftElement pointerEvents='none'>
                                    <SearchIcon color="gray.400" />
                                </InputLeftElement>
                                <Input
                                    borderColor={borderColor}
                                    borderRadius="xl"
                                    placeholder={t("Recherche...")}
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setCurrentPage(0)
                                        setSearchTerm(e.target.value)
                                    }}
                                    _focus={{ borderColor: 'purple.500', boxShadow: 'none' }}
                                />
                            </InputGroup>

                            <IconButton
                                icon={<GrPowerReset />}
                                onClick={resetFilters}
                                variant="outline"
                                colorScheme="purple"
                                rounded="xl"
                                aria-label={t("Réinitialiser")}
                                title={t("Réinitialiser les filtres")}
                            />
                        </Flex>
                    </Flex>


                    {selectedRows.length > 0 && (
                        <Flex position="sticky" top="0" zIndex="20"
                            mb={2}
                            gap={{ base: 2, md: 3 }}
                            w="100%"
                            align={{ base: 'flex-start', md: 'center' }}
                            bg={bgPurple}
                            p={3}
                            rounded="md"
                            direction={{ base: 'column', sm: 'row' }}
                            flexWrap="wrap"
                        >
                            <Text fontWeight="bold" whiteSpace="nowrap">
                                {selectedRows.length} {t("sélectionné(s)")}
                            </Text>

                            <Flex gap={2} flexWrap="wrap" align="center">
                                {user?.role !== 'LIVREUR' && (
                                    <Button size="sm" colorScheme="purple" isLoading={isBulkSubmitting} onClick={() => assign_order_to(user.id)}>
                                        <RiUserShared2Line style={{ marginRight: '5px' }} />
                                        {t("M'attribuer")}
                                    </Button>
                                )}
                                <BulkStatusUpdateModal
                                    statusField="status_delivery"
                                    statusKey="status_delivery"
                                    statusOptions={[
                                        { value: 'Nouveau', label: 'Nouveau' },
                                        { value: 'Ramassé', label: 'Ramassé' },
                                        { value: 'Expédié', label: 'Expédié' },
                                        { value: 'Reçu à destination', label: 'Reçu à destination' },
                                        { value: 'Pendant la distribution', label: 'Pendant la distribution' },
                                        { value: 'Programmé', label: 'Programmé' },
                                        { value: 'Hors zone', label: 'Hors zone' },
                                        { value: 'Non atteint', label: 'Non atteint' },
                                        { value: 'Annulé', label: 'Annulé' },
                                        { value: 'Refusé', label: 'Refusé' },
                                        { value: 'Livré', label: 'Livré' },
                                        { value: 'Préparation du retour', label: 'Préparation du retour' },
                                        { value: "Retour à l'agence", label: "Retour à l'agence" },
                                        { value: "Retour à l'entrepôt", label: "Retour à l'entrepôt" },
                                    ]}
                                    selectedRows={selectedRows}
                                    dataList={dataOrder}
                                    onSuccess={(newStatus) => {
                                        if (newStatus) {
                                            setDataOrder(prev => prev.map(item =>
                                                selectedRows.includes(item.id)
                                                    ? { ...item, status_delivery: newStatus }
                                                    : item
                                            ));
                                        }
                                        setSelectedRows([]);
                                    }}
                                />

                                {user?.role !== 'LIVREUR' && (
                                    <Button size="sm" colorScheme="blue" isLoading={isBulkSubmitting} onClick={async () => {
                                        if (isBulkSubmitting) return;
                                        setIsBulkSubmitting(true);
                                        try {
                                            const res = await axiosClient.post(`/commandes/bulk_actions/`, {
                                                action: 'send_to_shipping',
                                                user_id: user.id,
                                                order_ids: selectedRows
                                            });
                                            const abortController = new AbortController();
                                            fetchData(abortController.signal);
                                            const results = res.data.results || [];
                                            const errors = results.filter(r => !r.success);
                                            const successes = results.filter(r => r.success);
                                            
                                            if (successes.length > 0) {
                                                toast({
                                                    description: `${successes.length} commande(s) envoyée(s) au transporteur avec succès.`,
                                                    status: 'success',
                                                    duration: 3000,
                                                    isClosable: true,
                                                    position: 'bottom-right'
                                                });
                                            }

                                            if (errors.length > 0) {
                                                errors.forEach(err => {
                                                    toast({
                                                        description: `Erreur - Commande ${err.order_code}: ${err.message}`,
                                                        status: 'error',
                                                        duration: 5000,
                                                        isClosable: true,
                                                        position: 'bottom-right'
                                                    });
                                                });
                                            }
                                            setSelectedRows([]);
                                        } catch (err) {
                                            toast({
                                                description: t("Erreur lors de l'envoi au transporteur"),
                                                status: 'error',
                                                duration: 3000,
                                                isClosable: true,
                                                position: 'bottom-right'
                                            });
                                        } finally {
                                            setIsBulkSubmitting(false);
                                        }
                                    }}>
                                        <RiFileTransferLine style={{ marginRight: '5px' }} />
                                        {t("Envoyer au transporteur")}
                                    </Button>
                                )}
                            </Flex>
                        </Flex>
                    )}
                    <TableContainer ref={tableRef} maxH={selectedRows.length > 0 ? "calc(100vh - 180px)" : "calc(100vh - 80px)"} overflowY="auto" mx={{ base: -3, md: -7 }}>
                        <Table size={{ base: 'sm', md: 'md' }} variant='simple' style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                            <Thead>
                                <Tr>
                                    <Th borderBottomColor='gray.400' position="sticky" left={0} top={0} zIndex={4} bg="white" _dark={{ bg: "gray.700" }}>
                                        <Checkbox
                                            size="md"
                                            colorScheme='purple'
                                            onChange={handleSelectAll}
                                            isChecked={selectedRows.length === dataOrder.length && dataOrder.length > 0}
                                        />
                                    </Th>
                                    <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("#ID")}</Th>
                                    <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Client")}</Th>
                                    <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Adresse")}</Th>
                                    <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("téléphone")}</Th>
                                    <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Status")}</Th>
                                    <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Coupons")}</Th>
                                    <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Prix")}</Th>
                                    <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Date Création")}</Th>
                                    <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Date Modification")}</Th>
                                    <Th borderBottomColor='gray.400' position="sticky" right={0} top={0} zIndex={4} bg="white" _dark={{ bg: "gray.700" }}>{t("Options")}</Th>
                                </Tr>
                            </Thead>
                            <Tbody>

                                {loading &&
                                    <Tr>
                                        <Td><Skeleton height="20px" /></Td>
                                        <Td><Skeleton h={10} w={10} /></Td>
                                        <Td><Skeleton height='20px' /></Td>
                                        <Td>
                                            <Flex flexDirection={"column"} gap={2}>
                                                <Skeleton height='20px' />
                                                <Skeleton height='10px' />
                                            </Flex>
                                        </Td>
                                        <Td>
                                            <Flex flexDirection={"column"} gap={2}>
                                                <Skeleton height='20px' />
                                                <Skeleton height='10px' />
                                                <Skeleton height='10px' />
                                            </Flex>
                                        </Td>
                                        <Td><Skeleton height='20px' /></Td>
                                        <Td><Skeleton height='20px' /></Td>
                                        <Td><Skeleton height='20px' /></Td>
                                        <Td><Skeleton height='20px' /></Td>
                                        <Td><Skeleton height='20px' /></Td>
                                    </Tr>
                                }
                                {
                                    dataOrder.length > 0 ?
                                        dataOrder.map((val, key) => {
                                            return (
                                                <Tr
                                                    key={key}
                                                    cursor="pointer"
                                                    _hover={{ bg: "whiteAlpha.100" }}
                                                    onClick={() => {
                                                        saveScrollPosition(tableRef.current);
                                                        navigate('/Detail-Gestion-confirmation', {
                                                            state: {
                                                                id: val.id,
                                                                tel: val.tel
                                                            }
                                                        });
                                                    }}
                                                >
                                                    <Td position="sticky" left={0} zIndex={1} bg="white" _dark={{ bg: "gray.700" }} onClick={(e) => e.stopPropagation()}>
                                                        <Checkbox size="md" colorScheme='purple'
                                                            onChange={() => handleCheckboxClick(val.id)}
                                                            isChecked={selectedRows.includes(val.id)} />
                                                    </Td>
                                                    <Td>{val.code}</Td>
                                                    <Td>
                                                        <Flex flexDirection={"column"}>
                                                            <Text fontWeight='semibold'>{val.full_name}</Text>
                                                            {val.email !== "undefined" && <Text fontSize='sm' color={textSM}>{val.email}</Text>}
                                                        </Flex>
                                                    </Td>
                                                    <Td>
                                                        <Flex flexDirection={"column"}>
                                                            <Text fontSize={'md'}>{val.pays}, {val.ville}</Text>
                                                            <Text fontSize={'sm'} color={textSM}>{val.address}</Text>
                                                        </Flex>
                                                    </Td>
                                                    <Td>
                                                        <a href={`https://wa.me/${val.tel}`} target='blank' onClick={(e) => e.stopPropagation()}>
                                                            {val.tel}
                                                        </a>
                                                    </Td>
                                                    <Td>
                                                        <Badge colorScheme={
                                                            val?.status_delivery !== 'Collecté'
                                                                ? (['Épuisé', 'Annulé'].includes(val?.status_delivery))
                                                                    ? 'red'
                                                                    : ([null, ''].includes(val?.status_delivery))
                                                                        ? 'blue'
                                                                        : 'orange'
                                                                : 'green'
                                                        } rounded="xl" px={2} cursor='pointer' textTransform='uppercase' onClick={(e) => { e.stopPropagation(); onOpenAlert(val.id) }}>
                                                            {val?.status_delivery ? val?.status_delivery : 'Nouveau'}
                                                        </Badge>
                                                    </Td>
                                                    <Td>
                                                        <Text textAlign='center'>
                                                            {val.coupon ? val.couponTitle : '-'}
                                                        </Text>
                                                    </Td>
                                                    <Td>
                                                        <Flex gap={1} alignItems="center">
                                                            <Text color={val?.coupon && 'gray.400'} fontSize={val?.coupon && 15} fontWeight='semibold' textDecoration={val?.coupon && 'line-through'}>{val?.price}</Text>
                                                            <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                                                        </Flex>
                                                        {
                                                            val?.coupon &&
                                                            <Flex gap={1} alignItems="center">
                                                                <Text fontWeight='semibold'>{val?.priceWithCoupon}</Text>
                                                                <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                                                            </Flex>
                                                        }
                                                    </Td>
                                                    <Td>
                                                        <Flex flexDirection="column">
                                                            <Text fontSize="sm" fontWeight="medium">{new Date(val.date_creation).toLocaleDateString()}</Text>
                                                            <Text fontSize="xs" color="gray.500">{new Date(val.date_creation).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                                                        </Flex>
                                                    </Td>
                                                    <Td>
                                                        {val.date_modification ? (
                                                            <Flex flexDirection="column">
                                                                <Text fontSize="sm" fontWeight="medium">{new Date(val.date_modification).toLocaleDateString()}</Text>
                                                                <Text fontSize="xs" color="gray.500">{new Date(val.date_modification).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                                                            </Flex>
                                                        ) : (
                                                            <Text fontSize="sm" color="gray.400">-</Text>
                                                        )}
                                                    </Td>
                                                    <Td position="sticky" right={0} zIndex={1} bg="white" _dark={{ bg: "gray.700" }} onClick={(e) => e.stopPropagation()}>
                                                        <Menu>
                                                            <MenuButton
                                                                as={IconButton}
                                                                aria-label='Options'
                                                                icon={<CiMenuKebab />}
                                                                variant='outline'
                                                            />
                                                            <Portal>
                                                                <MenuList zIndex={9999}>
                                                                    <MenuItem icon={<TbListDetails size={18} />} onClick={() => {
                                                                        saveScrollPosition(tableRef.current);
                                                                        navigate('/Detail-Gestion-confirmation', {
                                                                            state: {
                                                                                id: val.id,
                                                                                tel: val.tel
                                                                            }
                                                                        });
                                                                    }}>
                                                                        {t("Détails")}
                                                                    </MenuItem>
                                                                    <MenuItem icon={<FaRegEye size={18} />} onClick={() => onOpenPreview(val.id)}>
                                                                        {t("Aperçu")}
                                                                    </MenuItem>
                                                                </MenuList>
                                                            </Portal>
                                                        </Menu>
                                                    </Td>
                                                </Tr>
                                            )
                                        })
                                        :
                                        <Tr>
                                            <Td colSpan={7}>
                                                <Text fontSize={18}>{t("Donnée introuvable")}</Text>
                                            </Td>
                                        </Tr>
                                }
                            </Tbody>
                        </Table>
                    </TableContainer>

                    {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}
                    <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                        <Box flex="1">
                            <MyPagination
                                paginationData={paginationData}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                PAGE_SIZE={pageSize}
                            />
                        </Box>

                        <Select rounded={"md"} size={"sm"} w="70px" value={pageSize} onChange={handlePageSizeChange}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </Select>
                    </Flex >
                    {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}

                </Stack >


                {/* Alert to Update confirmation status */}

                < AlertDialog
                    isOpen={isAlertOpen}
                    leastDestructiveRef={cancelRef}
                    onClose={onCloseAlert}
                >
                    <AlertDialogOverlay>
                        <AlertDialogContent>
                            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                                {t('Statut de livraison')}
                            </AlertDialogHeader>

                            <AlertDialogBody>
                                <Text>
                                    {t('Ici, vous pouvez modifier le statut de livraison.')}
                                </Text>

                                <Select
                                    mt={3}
                                    rounded='lg'
                                    size={"sm"}
                                    value={statusDelivery}
                                    onChange={e => setStatusDelivery(e.target.value)}
                                >
                                    <option value="">{t("Statut de livraison")}</option>
                                    <option value='Ramassé'>{t('Ramassé')}</option>
                                    <option value='Expédié'>{t('Expédié')}</option>
                                    <option value='Reçu à destination'>{t('Reçu à destination')}</option>
                                    <option value='Pendant la distribution'>{t('Pendant la distribution')}</option>
                                    <option value='Programmé'>{t('Programmé')}</option>
                                    <option value='Hors zone'>{t('Hors zone')}</option>
                                    <option value='Non atteint'>{t('Non atteint')}</option>
                                    <option value='Annulé'>{t('Annulé')}</option>
                                    <option value='Refusé'>{t('Refusé')}</option>
                                    <option value='Livré'>{t('Livré')}</option>
                                    <option value='Préparation du retour'>{t('Préparation du retour')}</option>
                                    <option value="Retour à l'agence">{t("Retour à l'agence")}</option>
                                    <option value="Retour à l'entrepôt">{t("Retour à l'entrepôt")}</option>
                                </Select>
                            </AlertDialogBody>

                            <AlertDialogFooter>
                                <Button colorScheme='yellow' size="sm" variant='outline' isLoading={isUpdatingStatus} isDisabled={!statusDelivery || isUpdatingStatus} mr={3} onClick={HandleChangeStatus}>
                                    {t('Modifier')}
                                </Button>
                                <Button onClick={onCloseAlert} isDisabled={isUpdatingStatus} size="sm" >{t('Annuler')}</Button>
                            </AlertDialogFooter>
                        </AlertDialogContent>
                    </AlertDialogOverlay>
                </AlertDialog>
            </Flex>


            {/* Preview Order */}
            <PreviewOrderModal
                isOpen={isPreviewOpen}
                onClose={onClosePreview}
                orderId={previewId}
            />

        </Box>
    )
}

export default GestSuivi